module.exports = __webpack_public_path__ + "img/ki.ac793c98.svg";